var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReflectmagic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.625 18.406c-19.833 0-35.688 15.888-35.688 35.72 0 19.833 15.854 35.687 35.688 35.687 19.83 0 35.72-15.857 35.72-35.688 0-19.834-15.89-35.72-35.72-35.72zM93.97 65.25c-5.68 13.142-8.94 26.858-8.94 41.5 0 45.29 29.44 85.21 74.157 108.625L15.75 494.5h77.28l123.564-390.813-37.406 72.813c-50.628-20.564-85.22-61.99-85.22-109.75 0-.505-.007-.977 0-1.5zm315.405 0c.007.505 0 .977 0 1.5 0 46.98-33.468 87.856-82.75 108.75l-39.063-76 129.688 395h73.344L346.47 214.125c43.408-23.57 71.842-62.875 71.842-107.375 0-14.626-3.272-28.37-8.937-41.5zm-173.97 40.938L112.626 494.5h75.47l47.31-388.313zm36.032 4.156L318.25 494.5h79.313L271.438 110.344zm-18.28 4.5L206.906 494.5h92.5l-46.25-379.656z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReflectmagic);
export default __webpack_public_path__ + "static/media/reflectmagic.f7c6295624bf2dc6ddec8d83da7f9329.svg";
export { ForwardRef as ReactComponent };